import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router';
import { success_retrieve_tenant_information } from '../reducers/auth_tenant/retrieve_tenant_information_Slice';
import { success_retrieve_tenant_user_information } from '../reducers/auth_tenant/retrieve_tenant_user_information_Slice';
import * as app_consts from "../utils/app_consts";
import { getFirstPathAfterCom, getTenantURLPrefix, messageToast } from '../utils/Utils';
import Layout from '../layout/Index';
import AdminTenantsList from '../pages/admin_tenant/AdminTenantsList';
import { useSelector } from 'react-redux';
import OrderList from '../pages/tenant_dashboard_pages/orders/OrderList';
import Products from '../pages/tenant_dashboard_pages/products/Products';
import WarehouseSites from '../pages/tenant_dashboard_pages/warehouse_sites/WarehouseSites';
import WarehouseInventory from '../pages/tenant_dashboard_pages/warehouse_inventory/WarehouseInventory';
import ProductManagement from '../pages/tenant_dashboard_pages/products/ProductManagement';
import AuditTrails from '../pages/tenant_dashboard_pages/audit_trails/AuditTrails';
import EmployeeManagement from '../pages/tenant_dashboard_pages/employees/EmployeeManagement';
import SettingsManagement from '../pages/tenant_dashboard_pages/settings/SettingsManagement';
import EmployeeDetails from '../pages/tenant_dashboard_pages/employees/EmployeeDetails';
import ProductDetails from '../pages/tenant_dashboard_pages/products/ProductDetails';
import { Alert, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { BlockBetween, BlockHeadContent, Button, Col, Icon, Row } from '../components/Component';
import SalesRepManagement from '../pages/tenant_dashboard_pages/sales_rep/SalesRepManagement';
import ProductsListings from '../pages/webstore/ProductsListings';
import ProductsListingDetails from '../pages/webstore/ProductsListingDetails';
import OrderListingDetails from '../pages/webstore/OrderListingDetails';
import OrderListings from '../pages/webstore/OrderListings';
import OrderDetails from '../pages/tenant_dashboard_pages/orders/OrderDetails';
import AdminTenantDetails from '../pages/admin_tenant/AdminTenantDetails';
import GoodsReceievedManagement from '../pages/tenant_dashboard_pages/goods_received/GoodsReceievedManagement';
import TenantDashboard from '../pages/tenant_dashboard_pages/dashboard/TenantDashboard';
import StockTakeManagement from '../pages/tenant_dashboard_pages/stock_take/StockTakeManagement';
import StockTakeDetails from '../pages/tenant_dashboard_pages/stock_take/StockTakeDetails';
import TextInput from '../pages/components/inputs/TextInput';
import { tenant_auth_actions_helper, tenant_no_auth_actions_helper } from '../actions/actions_helper';
import { fail_sign_in_auth, loading_sign_in_auth, reset_sign_in_auth, success_sign_in_auth } from '../reducers/auth_tenant/sign_in_auth_Slice';
import { SEND_TENANT_USER_ACCOUNT_OTP_ERROR_MSG, SEND_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG, VERIFY_TENANT_USER_ACCOUNT_OTP_ERROR_MSG, VERIFY_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG } from '../utils/error_success_messages';
import { AUTH_RESIGN_TENANT_API, VERIFY_TENANT_USER_ACCOUNT_OTP_API } from '../api/api_data';
import { fail_verify_resign_in_otp, loading_verify_resign_in_otp, reset_verify_resign_in_otp, success_verify_resign_in_otp } from '../reducers/auth_tenant/verify_resign_in_otp_Slice';
import { reset_auth_sign_out } from '../reducers/auth_tenant/auth_sign_out_Slice';
import AnalyticsManagement from '../pages/tenant_dashboard_pages/analytics/AnalyticsManagement';
import AllOrderListingDetatils from '../pages/webstore/order_data/AllOrderListingDetatils';
import AgenciesManagement from '../pages/tenant_dashboard_pages/agencies/AgenciesManagement';
import AgencyDetails from '../pages/tenant_dashboard_pages/agencies/AgencyDetails';
import ProductsValuation from '../pages/tenant_dashboard_pages/products_valuation/ProductsValuation';
import BudgetAllocations from '../pages/tenant_dashboard_pages/budget_allocations/BudgetAllocations';
import BudgetAllocationDetails from '../pages/tenant_dashboard_pages/budget_allocations/BudgetAllocationDetails';
import StockLevelsManagement from '../pages/tenant_dashboard_pages/stock_levels/StockLevelsManagement';
import SalesRepsDetails from '../pages/tenant_dashboard_pages/sales_rep/SalesRepsDetails';
import OrdersReportsManagement from '../pages/tenant_dashboard_pages/reports/OrdersReportsManagement';
import { fail_retrieve_module_information, success_retrieve_module_information } from '../reducers/auth_tenant/retrieve_module_information_Slice';
import PromotionsDashboard from '../pages/tenant_dashboard_pages/promotions/dashboard/PromotionsDashboard';
import PromotionsList from '../pages/tenant_dashboard_pages/promotions/promotions/PromotionsList';
import ParticipantsList from '../pages/tenant_dashboard_pages/promotions/participants/ParticipantsList';
import PromotionsSettings from '../pages/tenant_dashboard_pages/promotions/settings/PromotionsSettings';
import PromotionsEmployees from '../pages/tenant_dashboard_pages/promotions/employees/PromotionsEmployees';
import PromotionsAuditTrails from '../pages/tenant_dashboard_pages/promotions/audit_trails/PromotionsAuditTrails';
import PromotionsDetails from '../pages/tenant_dashboard_pages/promotions/promotions/PromotionsDetails';
import PromotionEmployeeDetails from '../pages/tenant_dashboard_pages/promotions/employees/PromotionEmployeeDetails';
import StockAgeAnalysisManagementDashboardHub from '../pages/tenant_dashboard_pages/reports/stock_age_analysis/StockAgeAnalysisManagementDashboardHub';
import GoodsIssuedManagement from '../pages/tenant_dashboard_pages/goods_issued/GoodsIssuedManagement';

// Load First 
const currentUrl = window.location.href;
const main_tenant_url_prefix = getFirstPathAfterCom(currentUrl);

const AuthTenants = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [tenant_info, setTenantInfo] = useState(null);
  const [user_info, setUserInfo] = useState(null);
  const [log_out, setLogOut] = useState(false);
  const [otp_sent, setOtpSent] = useState(false);
  const [otp_error, setOtpError] = useState("");
  const [otp_loading, setOTPLoading] = useState(false);
  const [otp_value, setOTPValue] = useState('');
  const [resign_follow_up, setResignFollowUp] = useState([]);
  const [mod_info, setModInfo] = useState(null);

  // Load tenant info from local storage
  useEffect(() => {
    const storedTenant = localStorage.getItem("dashboard_tenant");
    const storedProfiles = localStorage.getItem("user_account");
    const module_name = localStorage.getItem("module_name");

    if (storedTenant)
    {
      const tenant_data = JSON.parse(storedTenant);
      const user_data = JSON.parse(storedProfiles);
      const parsed_module_name = JSON.parse(module_name);

      if (user_data?.length === 0)
      {
        dispatch(success_retrieve_tenant_information(tenant_data));
        dispatch(success_retrieve_tenant_user_information(user_data));
      }
      else
      {
        // Check Module Name
        if (parsed_module_name)
        {
          const mod = user_data?.find((prof) => {
            return prof?.module_name === parsed_module_name;
          }
          );

          if (mod)
          {
            dispatch(success_retrieve_tenant_user_information(mod));
            dispatch(success_retrieve_module_information({ module_name: mod?.module_name }));
          }
          else
          {
            dispatch(fail_retrieve_module_information());
          }
        }
        else
        {
          dispatch(success_retrieve_tenant_user_information(user_data));
        }
        dispatch(success_retrieve_tenant_information(tenant_data));
      }
    }
  }, [dispatch]);

  // Get tenant information from Redux store
  const tenant_information = useSelector((state) => state.retrieve_tenant_information.retrieve_tenant_information);

  // Update state and navigate when tenant information is available
  useEffect(() => {
    if (tenant_information?.status === app_consts.SUCCESS && (tenant_information?.data?.url_prefix !== main_tenant_url_prefix))
    {
      localStorage?.clear();
      window.location.assign(`/${main_tenant_url_prefix}`);
    }
    else
    {
      setTenantInfo(tenant_information.data);
    }
  }, [tenant_information, navigate]);

  const auth_sign_out_listener = useSelector((state) => state.auth_sign_out.auth_sign_out);

  useEffect(() => {
    if (auth_sign_out_listener.status === app_consts.SUCCESS)
    {
      setLogOut(true);
      if (user_information?.data?.type === app_consts.TENANT)
      {
        setResignFollowUp(auth_sign_out_listener?.data);
      }
    }
  }, [auth_sign_out_listener]);

  // Get tenant information from Redux store
  const user_information = useSelector((state) => state.retrieve_tenant_user_information.retrieve_tenant_user_information);

  // Update state and navigate when tenant information is available
  useEffect(() => {
    if (user_information?.status === app_consts.SUCCESS)
    {
      setUserInfo(user_information.data);
    }
  }, [user_information, navigate]);

  const toggleTop = () => {
    // Clear LocalStorage and REfresh Page
    localStorage.removeItem("profile_access");
    localStorage.removeItem("user_account");
    window.location.assign(`/${tenant_info.url_prefix}/auth`);
    navigate();
  };

  const handleSendOtp = () => {
    setOtpError("");

    if (user_information?.data?.type === app_consts.TENANT)
    {
      dispatch(tenant_no_auth_actions_helper(loading_sign_in_auth, success_sign_in_auth, fail_sign_in_auth, SEND_TENANT_USER_ACCOUNT_OTP_ERROR_MSG, SEND_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${AUTH_RESIGN_TENANT_API}/${user_information?.data?.account_id}`));
    }
  };
  // //  Listen
  const sign_in_auth_listener = useSelector((state) => state.sign_in_auth.sign_in_auth);

  useEffect(() => {
    if (sign_in_auth_listener.status !== app_consts.IDLE)
    {
      if (sign_in_auth_listener.status === app_consts.LOADING)
      {
        setOTPLoading(true);
        setOtpError("");
      } else
      {
        setOTPLoading(false);
        if (sign_in_auth_listener.status === app_consts.FAIL)
        {
          setOtpError(sign_in_auth_listener.message);
          messageToast(sign_in_auth_listener.message, app_consts.FAIL);
        } else if (sign_in_auth_listener.status === app_consts.SUCCESS)
        {
          messageToast(SEND_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG, app_consts.SUCCESS);
          setOtpSent(true);
          setOTPValue("");
        }
        dispatch(reset_sign_in_auth());
      }
    }
  }, [sign_in_auth_listener]);

  // Handle Submit
  const handleSubmitOTP = () => {
    setOtpError("");


    if (user_information?.data?.type === app_consts.TENANT)
    {
      dispatch(tenant_no_auth_actions_helper(loading_verify_resign_in_otp, success_verify_resign_in_otp, fail_verify_resign_in_otp, VERIFY_TENANT_USER_ACCOUNT_OTP_ERROR_MSG, VERIFY_TENANT_USER_ACCOUNT_OTP_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${VERIFY_TENANT_USER_ACCOUNT_OTP_API}`, { account_id: user_information?.data?.account_id, otp: otp_value }));
    }


  };
  //  Listen
  const verify_resign_in_otp_listener = useSelector((state) => state.verify_resign_in_otp.verify_resign_in_otp);

  useEffect(() => {
    if (verify_resign_in_otp_listener.status !== app_consts.IDLE)
    {
      if (verify_resign_in_otp_listener.status === app_consts.LOADING)
      {
        setOTPLoading(true);
        setOtpError("");
      } else
      {
        if (verify_resign_in_otp_listener.status === app_consts.FAIL)
        {
          setOTPLoading(false);
          setOtpError(verify_resign_in_otp_listener.message);
          messageToast(verify_resign_in_otp_listener.message, app_consts.FAIL);
        } else if (verify_resign_in_otp_listener.status === app_consts.SUCCESS)
        {

          const timer = setTimeout(() => {
            if (user_information?.data?.type === app_consts.TENANT)
            {
              dispatch(tenant_auth_actions_helper(resign_follow_up?.loadingState, resign_follow_up?.successState, resign_follow_up?.failState, resign_follow_up?.errorMessage, resign_follow_up?.successMessage, resign_follow_up?.apiReqType, resign_follow_up?.apiEndpoint, resign_follow_up?.formData));
            }
            setOtpSent(false);
            setOTPValue("");
            setLogOut(false);
            setOTPLoading(false);
            dispatch(reset_auth_sign_out());
          }, 1500);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_verify_resign_in_otp());
      }
    }
  }, [verify_resign_in_otp_listener]);

  const module_information = useSelector((state) => state.retrieve_module_information.retrieve_module_information);

  useEffect(() => {
    if (module_information?.status === app_consts.SUCCESS)
    {
      setModInfo(module_information.data);
    }
    else if (module_information?.status === app_consts.FAIL)
    {
      setModInfo(app_consts.SELECT_MODULE);
    }
  }, [module_information, navigate]);

  return (
    <>
      <Modal isOpen={log_out} className="modal-dialog-top">
        <ModalHeader
          toggle={toggleTop}
        >
          Session Expired
        </ModalHeader>
        <ModalBody>
          <p>
            Please Sign in Again to Continue Using the System.
          </p>
          <Row className="g-4">
            <TextInput
              label="OTP"
              type="text"
              id_val="name"
              value={otp_value}
              colSize="12"
              required
              name="name"
              disabled={!otp_sent}
              handleChange={(e) => setOTPValue(e.target.value)}
            />
          </Row>
          <Row className="g-2 mt-1">

            {otp_error && (
              <div className="mb-3">
                <Alert color="danger" className="alert-icon">
                  <Icon name="alert-circle" /> {otp_error}
                </Alert>
              </div>
            )}
            <Col xl="12" className="d-flex justify-content-end">
              {
                otp_sent ?
                  <>
                    <div className="form-group">
                      <Button
                        color="primary"
                        size="lg"
                        className="btn-block"
                        disabled={otp_loading || !otp_value}
                        onClick={handleSubmitOTP}
                      >
                        {otp_loading ? <Spinner size="sm" color="light" /> : 'Verify OTP'}
                      </Button>
                    </div>
                  </>
                  :
                  <>
                    <div className="form-group">
                      <Button
                        color="primary"
                        size="lg"
                        className="btn-block"
                        disabled={otp_sent ? otp_loading || !otp_value : false}
                        onClick={handleSendOtp}
                      >
                        {otp_loading ? <Spinner size="sm" color="light" /> : 'Send OTP'}
                      </Button>
                    </div>
                  </>
              }
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="bg-light d-flex justify-content-start">
          <Button onClick={toggleTop} color="danger">
            Log Out
          </Button>
        </ ModalFooter>
      </Modal>
      {tenant_info && user_info && (
        <Routes>
          <Route path="/" element={<Layout tenant_info={tenant_info} />}>
            {
              user_info?.access_level === app_consts.EMPLOYEE ?
                <>
                  {
                    user_info?.type === app_consts.ADMIN ?
                      <>
                        <Route path={`/${tenant_info.url_prefix}/tenants`} index element={<AdminTenantsList tenant_info={tenant_info} user_info={user_info} />} />
                        <Route path={`/${tenant_info.url_prefix}/tenants/:id`} index element={<AdminTenantDetails tenant_info={tenant_info} user_info={user_info} />} />
                        <Route path="*" element={<Navigate to={`/${tenant_info.url_prefix}/tenants`} replace />} />
                        <Route path="" element={<Navigate to={`/${tenant_info.url_prefix}/tenants`} replace />} />
                      </>
                      :
                      <>
                        {/* Inventory */}
                        {
                          mod_info?.module_name && mod_info?.module_name === app_consts.INVENTOTY ?
                            <>
                              <Route path={`/${tenant_info.url_prefix}/dashboard`} index element={<TenantDashboard tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/orders`} element={<OrderList tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/orders/:order_ref_no`} element={<OrderDetails tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/products`} element={<Products tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/warehouse_inventory`} element={<WarehouseInventory tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/products_management`} element={<ProductManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/products_management/:product_id`} element={<ProductDetails tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/sales_rep`} element={<SalesRepManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/sales_rep/:id`} element={<SalesRepsDetails tenant_info={tenant_info} user_info={user_info} />} />



                              <Route path={`/${tenant_info.url_prefix}/goods_received`} element={<GoodsReceievedManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/goods_issued`} element={<GoodsIssuedManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/stock_take`} element={<StockTakeManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/stock_take/:reference_number`} element={<StockTakeDetails tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/agencies`} element={<AgenciesManagement tenant_info={tenant_info} user_info={user_info} />} />
                              <Route path={`/${tenant_info.url_prefix}/agencies/:id`} element={<AgencyDetails tenant_info={tenant_info} user_info={user_info} />} />

                              {/* Protect Routes with Admin */}

                              {
                                user_info?.roles?.includes(app_consts.ADMINISTRATOR) && (
                                  <>
                                    <Route path={`/${tenant_info.url_prefix}/reports/orders`} element={<OrdersReportsManagement tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/employees`} element={<EmployeeManagement tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/employees/:mobile_number`} element={<EmployeeDetails tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/audit_trails`} element={<AuditTrails tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/settings`} element={<SettingsManagement tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/products_valuation`} element={<ProductsValuation tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/budget_allocations`} element={<BudgetAllocations tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/budget_allocations/:id`} element={<BudgetAllocationDetails tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/warehouse_sites`} element={<WarehouseSites tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/analytics`} element={<AnalyticsManagement tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/stock_levels`} element={<StockLevelsManagement tenant_info={tenant_info} user_info={user_info} />} />
                                    <Route path={`/${tenant_info.url_prefix}/reports/stock_age_analysis`} element={<StockAgeAnalysisManagementDashboardHub tenant_info={tenant_info} user_info={user_info} />} />
                                  </>
                                )
                              }



                              <Route path="*" element={<Navigate to={`/${tenant_info.url_prefix}/dashboard`} replace />} />
                              <Route path="" element={<Navigate to={`/${tenant_info.url_prefix}/dashboard`} replace />} />
                            </>
                            :
                            mod_info?.module_name && mod_info?.module_name === app_consts.PROMOTIONS ?
                              <>
                                <Route path={`/${tenant_info.url_prefix}/dashboard`} index element={<PromotionsDashboard tenant_info={tenant_info} user_info={user_info} />} />
                                <Route path={`/${tenant_info.url_prefix}/promotions`} index element={<PromotionsList tenant_info={tenant_info} user_info={user_info} />} />
                                <Route path={`/${tenant_info.url_prefix}/promotions/:promotion_id`} index element={<PromotionsDetails tenant_info={tenant_info} user_info={user_info} />} />
                                <Route path={`/${tenant_info.url_prefix}/participants`} index element={<ParticipantsList tenant_info={tenant_info} user_info={user_info} />} />


                                {
                                  user_info?.roles?.includes(app_consts.ADMINISTRATOR) && (
                                    <>
                                      <Route path={`/${tenant_info.url_prefix}/employees`} element={<PromotionsEmployees tenant_info={tenant_info} user_info={user_info} />} />
                                      <Route path={`/${tenant_info.url_prefix}/employees/:mobile_number`} element={<PromotionEmployeeDetails tenant_info={tenant_info} user_info={user_info} />} />
                                      <Route path={`/${tenant_info.url_prefix}/audit_trails`} element={<PromotionsAuditTrails tenant_info={tenant_info} user_info={user_info} />} />
                                      <Route path={`/${tenant_info.url_prefix}/settings`} element={<PromotionsSettings tenant_info={tenant_info} user_info={user_info} />} />
                                    </>
                                  )
                                }


                                <Route path="*" element={<Navigate to={`/${tenant_info.url_prefix}/dashboard`} replace />} />
                                <Route path="" element={<Navigate to={`/${tenant_info.url_prefix}/dashboard`} replace />} />
                              </>
                              :
                              <>

                              </>
                        }

                      </>
                  }
                </>
                :
                <>
                  <Route path={`/${tenant_info.url_prefix}/products`} index element={<ProductsListings tenant_info={tenant_info} user_info={user_info} />} />
                  <Route path={`/${tenant_info.url_prefix}/orders`} index element={<OrderListings tenant_info={tenant_info} user_info={user_info} />} />
                  <Route path={`/${tenant_info.url_prefix}/my_orders/:order_ref_no`} index element={<OrderListingDetails tenant_info={tenant_info} user_info={user_info} />} />
                  <Route path={`/${tenant_info.url_prefix}/all_orders/:order_ref_no`} index element={<AllOrderListingDetatils tenant_info={tenant_info} user_info={user_info} />} />

                  <Route path={`/${tenant_info.url_prefix}/products/:product_id`} element={<ProductsListingDetails tenant_info={tenant_info} user_info={user_info} />} />
                  <Route path="*" element={<Navigate to={`/${tenant_info.url_prefix}/products`} replace />} />
                  <Route path="" element={<Navigate to={`/${tenant_info.url_prefix}/products`} replace />} />
                </>
            }
          </Route>
        </Routes>
      )}
    </>
  );
};

export default AuthTenants;